export const CVC_TOOLTIP_MESSAGE =
  '3-digit security code usually found on the back of your card. American Express cards have a 4-digit code located on the front.';
